import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/$patientId/package/concierge')({
  component: ConciergePage,
});

function ConciergePage() {
  return (
    <>
      <div id="concierge-page" className="my-4 flex flex-col place-items-center">
        <p className="text-xl">You have selected the clinician guided package.</p>
        <div id="schedule-intake" className="my-4 flex flex-col place-content-center">
          <a
            target="_blank"
            rel="noreferrer"
            href="http://qr.mideohealth.com/GetScheduled"
            className="m-2 w-48 rounded-md bg-sky-700 px-4 py-2 text-center text-white hover:bg-sky-800 disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-500 disabled:shadow-none sm:px-8 sm:py-3"
          >
            Schedule Intake
          </a>
        </div>

        <a
          target="_blank"
          rel="noreferrer"
          href="http://mideohealth.com/for-patients/"
          className="m-2 w-48 rounded-md bg-sky-700 px-4 py-2 text-center text-white hover:bg-sky-800 disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-500 disabled:shadow-none sm:px-8 sm:py-3"
        >
          Learn More
        </a>
      </div>
    </>
  );
}
